export default [
  {
    id: 14,
    key: 'planStatus',
    name: '开关状态',
    value: '-2',
    field_type: 'enumeration',
    expression: '=',
    equalenums: [{ value: '=', label: '=' }],
    enum_property: [
      {
        value: '-2',
        label: '不限'
      },
      {
        value: '1',
        label: '启动'
      },
      {
        value: '0',
        label: '暂停'
      }
    ],
    unit: '',
    fixed: false
  },
  {
    id: 1,
    key: 'paperUseAmount',
    name: '账面消耗金额',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      },
      {
        label: '撞线',
        value: '=='
      }
    ],
    enum_property: [
      {
        value: 1,
        label: '100%'
      },
      {
        value: 0.9,
        label: '90%'
      },
      {
        value: 0.8,
        label: '80%'
      },
      {
        value: 0.7,
        label: '70%'
      },
      {
        value: 0.6,
        label: '60%'
      },
      {
        value: 0.5,
        label: '50%'
      },
      {
        value: 0.4,
        label: '40%'
      },
      {
        value: 0.3,
        label: '30%'
      },
      {
        value: 0.2,
        label: '20%'
      },
      {
        value: 0.1,
        label: '10%'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 2,
    key: 'amount',
    name: '实际消耗金额',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 3,
    key: 'downNum',
    name: '激活数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '个',
    fixed: false
  },
  {
    id: 4,
    key: 'createRoleNum',
    name: '创角数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '个',
    fixed: false
  },
  {
    id: 5,
    key: 'newUserNum',
    name: '注册数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '个',
    fixed: false
  },
  {
    id: 18,
    key: 'clickRate',
    name: '点击率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '%',
    fixed: true
  },
  {
    id: 15,
    key: 'createRoleCost',
    name: '创角成本',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 16,
    key: 'activeDeviceCost',
    name: '激活成本',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 6,
    key: 'payActiveDeviceNum',
    name: '新增付费设备数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '台',
    fixed: false,
    unShow: [-10]
  },
  {
    id: 7,
    key: 'payRoleUserNum',
    name: '新增付费创角数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '个',
    fixed: false
  },
  {
    id: 17,
    key: 'newRoleMoney',
    name: '新创角付费金额',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 8,
    key: 'newPayRoleUserRate',
    name: '新创角付费率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '%',
    fixed: true
  },
  {
    id: 21,
    key: 'newPayCost',
    name: '新创角付费成本',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 9,
    key: 'payActiveDeviceNumRate',
    name: '新设备付费率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '%',
    fixed: true,
    unShow: [-10]
  },
  {
    id: 10,
    key: 'newActiveTurnOverRate',
    name: '新激活回款率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '%',
    fixed: true,
    unShow: [-10]
  },
  {
    id: 11,
    key: 'newRoleRate',
    name: '新创角回款率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '%',
    fixed: true
  },
  {
    id: 12,
    key: 'sumMoney',
    name: '总流水',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 20,
    key: 'createTime',
    name: '新建时间',
    value: '',
    field_type: 'string',
    expression: '>',
    equalenums: [
      {
        label: '>',
        value: '>'
      },
      {
        label: '>=',
        value: '>='
      },
      {
        label: '<',
        value: '<'
      },
      {
        label: '<=',
        value: '<='
      }
    ],
    unit: '天',
    fixed: false,
    unShow: [-10]
  },
  // {
  //   id: 22,
  //   key: 'thirdPlanStatus',
  //   name: '广告状态',
  //   value: '-2',
  //   field_type: 'enumeration',
  //   expression: '=',
  //   equalenums: [{ value: '=', label: '=' }],
  //   enum_property: [
  //     {
  //       value: '-2',
  //       label: '不限'
  //     }
  //     // {
  //     //   value: '4',
  //     //   label: '审核不通过'
  //     // }
  //   ],
  //   fixed: false
  // },
  {
    id: 23,
    key: 'createRolePayTwiceRate',
    name: '首日二次付费率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '%',
    fixed: true,
    unShow: [-10]
  },
  {
    id: 24,
    key: 'roleLevelReachOneHourRate',
    name: '1小时等级通过率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '%',
    fixed: true,
    unShow: [-10]
  }
  // {
  //   id: 13,
  //   key: 'newRoleMoney',
  //   name: '创角总流水',
  //   value: '',
  //   field_type: 'string',
  //   expression: '>=',
  //   equalenums: [{
  //     label: '>=',
  //     value: '>='
  //   }, {
  //     label: '>',
  //     value: '>'
  //   }, {
  //     label: '<=',
  //     value: '<='
  //   }, {
  //     label: '<',
  //     value: '<'
  //   }],
  //   unit: '元',
  //   fixed: true
  // }
]
